import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2, XCircle } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 bg-[#2D3748] text-white relative overflow-hidden" data-id="element-16">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-17">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-[#E07856] rounded-full blur-3xl" data-id="element-18" />
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-[#5B9BD5] rounded-full blur-3xl" data-id="element-19" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-20">
        <div className="grid lg:grid-cols-2 gap-16 mb-20" data-id="element-21">
          {/* Who it is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white/5 rounded-2xl p-8 border border-white/10" data-id="element-22">
            <h3 className="text-2xl font-bold text-[#8BA888] mb-6 flex items-center" data-id="element-23">
              <CheckCircle2 className="w-8 h-8 mr-3" data-id="element-24" />
              Esto es para ti si:
            </h3>
            <ul className="space-y-4 text-lg text-gray-200" data-id="element-25">
              <li className="flex items-start" data-id="element-26">
                <span className="mr-3 text-[#8BA888]" data-id="element-27">•</span>
                Estás cansada de "empezar el lunes" y fallar
              </li>
              <li className="flex items-start" data-id="element-28">
                <span className="mr-3 text-[#8BA888]" data-id="element-29">•</span>
                Quieres sentirte más ligera sin extremos
              </li>
              <li className="flex items-start" data-id="element-30">
                <span className="mr-3 text-[#8BA888]" data-id="element-31">•</span>
                Buscas un plan que cuide tu bolsillo
              </li>
            </ul>
          </motion.div>

          {/* Who it is NOT for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white/5 rounded-2xl p-8 border border-white/10" data-id="element-32">
            <h3 className="text-2xl font-bold text-[#E07856] mb-6 flex items-center" data-id="element-33">
              <XCircle className="w-8 h-8 mr-3" data-id="element-34" />
              No es para ti si:
            </h3>
            <ul className="space-y-4 text-lg text-gray-200" data-id="element-35">
              <li className="flex items-start" data-id="element-36">
                <span className="mr-3 text-[#E07856]" data-id="element-37">•</span>
                Buscas bajar mucho peso muy rápido (milagros)
              </li>
              <li className="flex items-start" data-id="element-38">
                <span className="mr-3 text-[#E07856]" data-id="element-39">•</span>
                Quieres entrenamientos fuertes de gimnasio
              </li>
              <li className="flex items-start" data-id="element-40">
                <span className="mr-3 text-[#E07856]" data-id="element-41">•</span>
                Necesitas un plan clínico personalizado
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.div id="cta-section" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto" data-id="element-42">
          <h2 className="text-4xl sm:text-5xl font-bold mb-8" data-id="element-43">
            La decisión real
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 mb-10 leading-relaxed" data-id="element-44">
            Puedes seguir pensando que "es la edad"... o puedes probar 14 días
            con una rutina que no te pide perfección.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-45">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={() => window.location.href = 'https://vitaliarutinas.com/cart/44388281679951:1'} className="w-full sm:w-auto px-10 py-5 bg-[#E07856] text-white text-xl font-bold rounded-xl shadow-lg hover:bg-[#c96242] transition-colors flex items-center justify-center cursor-pointer" data-id="element-46">
              Descargar "14 Días Desinflámate"
              <ArrowRight className="ml-3 w-6 h-6" data-id="element-47" />
            </motion.button>

            <div className="mt-2 flex items-center gap-3" data-id="element-48">
              <span className="text-gray-400 text-lg line-through" data-id="element-49">$19.99</span>
              <span className="text-3xl font-bold text-[#8BA888]" data-id="element-50">$6.39</span>
              <span className="px-3 py-1 bg-[#8BA888]/20 text-[#8BA888] rounded-full text-sm font-semibold" data-id="element-51">
                68% OFF
              </span>
            </div>

            <p className="text-gray-400 mt-2 text-lg" data-id="element-52">
              Acceso inmediato • Pago único y seguro
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}